import React, { useEffect, useState } from 'react';
import SendEmail from '../components/SendEmail';
import { fetchCreditNoteDetails, sendEmail } from '../../services/credit_note';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageLoader from '../../component/PageLoader';

function CreditNoteSendEmail() {
	const [creditNoteDetails, setCreditNoteDetails] = useState({});
	const navigate = useNavigate();
	const params = useParams();
	const { id } = params;
	const { userInfo } = useSelector((state) => state);
	const suburl = localStorage.getItem('suburl');
	const [toEmails, setToEmails] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [emailFormData, setEmailFormData] = useState({
		credit_note_id: null,
		credit_note_number: '',
		from: '',
		to: [],
		subject: '',
		body: '',
		isAttachment: true,
	});

	async function handleSend(formData) {
		try {
			await sendEmail(formData);
			toast.success('Email Sent Successfully.');
			navigate(`/user/${suburl}/credit-note`);
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	function handleClose() {
		navigate(`/user/${suburl}/credit-note`);
	}

	async function handleFetchCreditNoteDetails() {
		try {
			setIsLoading(true);
			const creditNoteDetails = await fetchCreditNoteDetails(id);
			setCreditNoteDetails(creditNoteDetails);
		} catch (error) {
			toast.error('Someting went wrong!');
		} finally {
			setIsLoading(false);
		}
	}

	useEffect(() => {
		if (id) {
			handleFetchCreditNoteDetails();
		}
	}, [id]);

	useEffect(() => {
		if (creditNoteDetails && userInfo) {
			const { credit_note_id, credit_note_number, vendor } = creditNoteDetails;
			const vendorContactEmailList = Array.from(
				new Set(
					(vendor?.contact_person || [])
						.filter((contact) => contact?.email)
						.map((contact) => contact.email),
				),
			);
			// const vendorContactEmailList =
			// 	vendor?.contact_person && vendor?.contact_person?.length > 0
			// 		? vendor?.contact_person
			// 				?.filter((contact) => {
			// 					if (contact?.email) {
			// 						return contact;
			// 					}
			// 				})
			// 				.map((contact) => {
			// 					return contact?.email;
			// 				})
			// 		: [];
			setEmailFormData((prev) => ({
				...prev,
				to: vendorContactEmailList,
				from: `${userInfo?.userInfo?.data?.first_name} ${userInfo?.userInfo?.data?.last_name}`,
				credit_note_id,
				credit_note_number,
				subject: `Credit Note from ${userInfo?.userInfo?.data?.first_name + ' ' + userInfo?.userInfo?.data?.last_name} (Credit Note Number #: ${credit_note_number})`,
			}));
			setToEmails(vendorContactEmailList);
		}
	}, [creditNoteDetails, userInfo]);

	if (isLoading) {
		return <PageLoader />;
	}

	return (
		<div>
			<SendEmail
			audience="vendor"
				pdfName="Credit Note"
				pdfId={`${creditNoteDetails?.credit_note_number}`}
				toEmails={toEmails}
				formData={emailFormData}
				handleSend={handleSend}
				handleClose={handleClose}
			/>
		</div>
	);
}

export default CreditNoteSendEmail;
